import React, { useState, useEffect, useCallback } from 'react';
import DynaModal from '../../../../Modal/DynaModal';
import DynaInput from '../../../../A13/DynaView/DynaInput';
import UtilsFunctions from '../../../../../utils/UtilsFunctions';
import { toast } from "react-toastify";
import './CalculationModal.scss';

const CalculationModal = ({ onClose, data, onSubmit }) => {
  const [inputValues, setInputValues] = useState({});
  const [checkedItems, setCheckedItems] = useState({});
  const [singleQuantity, setSingleQuantity] = useState('');
  const [total, setTotal] = useState(0);

  useEffect(() => {
    calculateTotal();
  }, [inputValues, checkedItems, singleQuantity]);

  const handleInputChange = useCallback((index, value) => {
    if (/^\d*$/.test(value)) {
      setInputValues(prev => ({ ...prev, [index]: value }));
    }
  }, []);

  const handleSingleQuantityChange = useCallback((value) => {
    if (/^\d*$/.test(value)) {
      setSingleQuantity(value);
    }
  }, []);

  const handleCheckboxChange = useCallback((index) => {
    setCheckedItems(prev => {
      const newCheckedItems = { ...prev, [index]: !prev[index] };
      // اگر چک‌باکس غیرفعال شد، مقدار ورودی را خالی و مقدار کل را صفر کن
      if (!newCheckedItems[index]) {
        setInputValues(prev => ({ ...prev, [index]: '' }));
      }

      return newCheckedItems;
    });
  }, []);

  const calculateTotal = () => {
    let sum = 0;

    data.forEach((item, index) => {
      if (checkedItems[index]) {
        const inputValue = parseFloat(inputValues[index]) || 0;
        sum += item.count * inputValue;
      }
    });

    sum += parseFloat(singleQuantity) || 0;
    setTotal(sum);
  };

  const handleSubmit = () => {
    if (total === 0) {
      toast.error("جمع کل نمی‌تواند صفر باشد. لطفاً مقادیر را وارد کنید.");
      return;
    }
    onSubmit(total)
    onClose();
  };

  return (
    <DynaModal onClose={onClose} className={'simple-modal-saden calc-modal'}>
      <div className="calc-modal-title">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="12"
          fill="none"
          viewBox="0 0 10 12"
        >
          <path
            fill="#FFD62E"
            d="M1 7.732c-1.333-.77-1.333-2.694 0-3.464L7 .804c1.333-.77 3 .192 3 1.732v6.928c0 1.54-1.667 2.502-3 1.732z"
          ></path>
        </svg>
        <h3>محاسبه تعداد</h3>
      </div>

      <div className='calc-modal-body'>
        <div className="table__box">
          <ul className="table__header">
            <li className="table__row">
              <div style={{ width: "45%" }} className="table__cell">نام کارتن</div>
              <div style={{ width: "25%" }} className="table__cell">تعداد موجود در کارتن</div>
              <div style={{ width: "15%" }} className="table__cell">تعداد ورودی</div>
              <div style={{ width: "15%" }} className="table__cell">تعداد کل</div>
            </li>
          </ul>
          <ul className='table__body'>
            {data?.length > 0 &&
              data?.map((item, index) => (
                <li key={index} className="table__row" onClick={() => handleCheckboxChange(index)}
                  style={{ cursor: "pointer" }}>
                  <div className="checkbox__cell" onClick={(e) => e.stopPropagation()}>
                    <input
                      type="checkbox"
                      name={`checkbox-${index}`}
                      id={`checkbox-${index}`}
                      checked={checkedItems[index] || false}
                      onChange={() => handleCheckboxChange(index)}
                    />
                    <label htmlFor={`checkbox-${index}`}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="7"
                        height="5"
                        fill="none"
                        viewBox="0 0 7 5"
                      >
                        <path
                          stroke="#fff"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="1.5"
                          d="M4 3.15L6.15 1M1 2.719l1.713 1.719L4.306 2.85"
                        ></path>
                      </svg>
                    </label>
                  </div>
                  <div style={{ width: "45%" }} className="table__cell">{item?.title}</div>
                  <div style={{ width: "25%" }} className="table__cell">{item?.count}</div>
                  <div style={{ width: "15%" }} className="table__cell input__cell" onClick={(e) => e.stopPropagation()}>
                    <input
                      type="text"
                      placeholder='مقدار را وارد کنید'
                      value={inputValues[index] || ''}
                      onChange={(e) => handleInputChange(index, e.target.value)}
                      disabled={!checkedItems[index]}
                    />
                  </div>
                  <div style={{ width: "15%" }} className="table__cell">
                    {(item.count * (parseFloat(inputValues[index]) || 0))}
                  </div>
                </li>
              ))
            }
          </ul>
        </div>

        <DynaInput
          label={"تعداد تکی"}
          name={"singleQuantity"}
          className={"solid-dyna-input"}
          placeholder={"تعداد تخم مرغ تکی را وارد کنید"}
          value={UtilsFunctions.addCommas(singleQuantity)}
          type={"text"}
          hasComma={true}
          setDataFromComponent={(data) => handleSingleQuantityChange(data.singleQuantity)}
        />
      </div>

      <div className='calc-modal-line'></div>

      <div className='calc-modal-end'>
        <span className='total'>جمع کل : {total}</span>
        <div className="modal-buttons">
          <button onClick={onClose} className="cancel-button">انصراف</button>
          <button onClick={handleSubmit} className="submit-button">ثبت</button>
        </div>
      </div>
    </DynaModal>
  );
}

export default CalculationModal;